/* SANSONE REDESIGN 2026 - interattivita sezioni custom */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* ---------- Toast ---------- */
    var toast = document.createElement('div');
    toast.className = 'sx-toast';
    document.body.appendChild(toast);
    var toastTimer;
    function showToast(html) {
      toast.innerHTML = html;
      toast.classList.add('show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2600);
    }

    /* ---------- Reveal on scroll ---------- */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('.sx .reveal').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.sx .reveal').forEach(function (el) { el.classList.add('in'); });
    }

    /* ---------- Selettore eta ---------- */
    document.querySelectorAll('[data-sx-age-root]').forEach(function (root) {
      var cards = root.querySelectorAll('.age-card');
      var panels = root.querySelectorAll('[data-age-panel]');
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          cards.forEach(function (c) { c.classList.remove('active'); });
          card.classList.add('active');
          panels.forEach(function (p) {
            p.hidden = p.dataset.agePanel !== card.dataset.age;
          });
        });
      });
    });

    /* ---------- Wishlist (localStorage) ---------- */
    var wish = [];
    try { wish = JSON.parse(localStorage.getItem('sb_wish') || '[]'); } catch (e) {}
    document.querySelectorAll('.sx .wish-btn').forEach(function (btn) {
      if (wish.indexOf(btn.dataset.wish) !== -1) btn.classList.add('loved');
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sx .wish-btn');
      if (!btn) return;
      var id = btn.dataset.wish;
      var idx = wish.indexOf(id);
      if (idx === -1) {
        wish.push(id);
        btn.classList.add('loved');
        showToast('Aggiunto ai <em>preferiti</em> ♡');
      } else {
        wish.splice(idx, 1);
        btn.classList.remove('loved');
        showToast('Rimosso dai preferiti');
      }
      try { localStorage.setItem('sb_wish', JSON.stringify(wish)); } catch (e2) {}
    });

    /* ---------- Quick add (Cart AJAX API + refresh drawer Dawn) ---------- */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sx .quick-add[data-variant]');
      if (!btn || btn.disabled) return;
      var original = btn.textContent;
      btn.textContent = 'Aggiungo…';
      var sectionsToFetch = ['cart-icon-bubble'];
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl) sectionsToFetch.push('cart-drawer');
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.variant), quantity: 1 }],
          sections: sectionsToFetch,
          sections_url: window.location.pathname
        })
      }).then(function (res) { return res.json(); }).then(function (data) {
        if (data.status && data.status !== 200) {
          btn.textContent = original;
          showToast(data.description || 'Prodotto non disponibile');
          return;
        }
        btn.textContent = 'Aggiunto ✓';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sansone-quick-add', cartData: data });
        }
        setTimeout(function () { btn.textContent = original; }, 1800);
        if (data.sections) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && data.sections['cart-icon-bubble']) {
            bubble.innerHTML = new DOMParser()
              .parseFromString(data.sections['cart-icon-bubble'], 'text/html')
              .querySelector('.shopify-section').innerHTML;
          }
          if (cartDrawerEl && data.sections['cart-drawer']) {
            var newDrawer = new DOMParser()
              .parseFromString(data.sections['cart-drawer'], 'text/html')
              .querySelector('cart-drawer');
            if (newDrawer) {
              cartDrawerEl.innerHTML = newDrawer.innerHTML;
              cartDrawerEl.classList.remove('is-empty');
              if (typeof cartDrawerEl.open === 'function') cartDrawerEl.open();
            }
          } else {
            showToast('Aggiunto al <em>carrello</em>');
          }
        } else {
          showToast('Aggiunto al <em>carrello</em>');
        }
      }).catch(function () {
        btn.textContent = original;
        showToast('Ops, riprova tra un attimo');
      });
    });

    /* ---------- Brand marquee ---------- */
    document.querySelectorAll('.sx .marquee').forEach(function (mq) {
      var track = mq.querySelector('.marquee-track');
      if (!track) return;
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      mq.appendChild(clone);
    });

    /* ---------- Testimonianze ---------- */
    document.querySelectorAll('[data-sx-testi]').forEach(function (root) {
      var slides = root.querySelectorAll('.testi-slide');
      var dots = root.querySelectorAll('.testi-dots button');
      if (!slides.length) return;
      var idx = 0, timer;
      function go(i) {
        idx = i;
        slides.forEach(function (s, j) { s.classList.toggle('active', j === i); });
        dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
      }
      function auto() { timer = setInterval(function () { go((idx + 1) % slides.length); }, 6000); }
      dots.forEach(function (d, j) {
        d.addEventListener('click', function () { clearInterval(timer); go(j); auto(); });
      });
      go(0); auto();
    });

    /* ---------- Coriandoli newsletter ---------- */
    function confetti() {
      var colors = ['#C2A269', '#E5C3B5', '#B7C3AE', '#FFFDF8'];
      for (var i = 0; i < 36; i++) {
        var c = document.createElement('div');
        var size = 5 + Math.random() * 7;
        c.style.cssText = 'position:fixed;z-index:9999;top:-12px;left:' + (Math.random() * 100) + 'vw;width:' + size + 'px;height:' + (size * 0.6) + 'px;background:' + colors[i % 4] + ';border-radius:2px;pointer-events:none;transform:rotate(' + (Math.random() * 360) + 'deg);';
        document.body.appendChild(c);
        (function (el) {
          var anim = el.animate([
            { transform: 'translateY(0) rotate(0deg)', opacity: 1 },
            { transform: 'translateY(' + (window.innerHeight + 40) + 'px) rotate(' + (540 + Math.random() * 360) + 'deg)', opacity: 0.7 }
          ], { duration: 2400 + Math.random() * 2200, easing: 'cubic-bezier(.2,.6,.4,1)' });
          anim.onfinish = function () { el.remove(); };
        })(c);
      }
    }
    if (document.querySelector('.sx [data-nl-success]')) {
      confetti();
      var nlTarget = document.querySelector('.sx .newsletter');
      if (nlTarget) nlTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* ---------- Back to top ---------- */
    var backBtn = document.createElement('button');
    backBtn.className = 'sx-back-to-top';
    backBtn.setAttribute('aria-label', 'Torna su');
    backBtn.innerHTML = '\u2191';
    document.body.appendChild(backBtn);

    var ticking = false;
    function updateBackBtn() {
      var y = window.scrollY || window.pageYOffset;
      if (y > 600) {
        backBtn.classList.add('visible');
      } else {
        backBtn.classList.remove('visible');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(updateBackBtn); ticking = true; }
    }, { passive: true });

    backBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
})();
